module.exports = __webpack_public_path__ + "media/images/help/step-3-a0d524f39ee05f44f73be45a2de3b1ff.png";